import { i18n } from "@tellescope/i18n";

export const formatStripeSubscriptionInterval = (interval?: string, intervalCount?: number): string => {
  if (!interval || !intervalCount) return i18n.t("/month", { ns: "utils" });

  if (intervalCount === 1) {
    return i18n.t("/{{interval}}", { ns: "utils", interval });
  }

  switch (interval) {
    case "day":
      return i18n.t("/{{count}} day", { ns: "utils", count: intervalCount });
    case "week":
      return i18n.t("/{{count}} week", { ns: "utils", count: intervalCount });
    case "month":
      return i18n.t("/{{count}} month", { ns: "utils", count: intervalCount });
    case "year":
      return i18n.t("/{{count}} year", { ns: "utils", count: intervalCount });
    default:
      return i18n.t("/{{amount}} {{interval}}", { ns: "utils", amount: intervalCount, interval });
  }
};
